"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCollapse = exports.CollapsePanel = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var hooks_1 = require("../utils/hooks");
var hooks_2 = require("./hooks");
var Panel_1 = require("./Panel");
Object.defineProperty(exports, "CollapsePanel", { enumerable: true, get: function () { return Panel_1.CollapsePanel; } });
var hooks_3 = require("./hooks");
Object.defineProperty(exports, "useCollapse", { enumerable: true, get: function () { return hooks_3.useCollapse; } });
function Collapse(props) {
    var _a = props.single, single = _a === void 0 ? false : _a, children = props.children, _b = props.defaultValue, defaultValue = _b === void 0 ? [] : _b, valueFromProps = props.value, onChange = props.onChange;
    var _c = hooks_1.useValue({ valueFromProps: valueFromProps, defaultValue: defaultValue, onChange: onChange }), value = _c.value, setValue = _c.setValue;
    var toggleActive = react_1.useCallback(function (val) {
        if (value.indexOf(val) === -1) {
            if (single) {
                setValue([val]);
            }
            else {
                setValue(tslib_1.__spreadArrays(value, [val]));
            }
        }
        else {
            // eslint-disable-next-line no-lonely-if
            if (single) {
                setValue([]);
            }
            else {
                setValue(value.filter(function (item) { return item !== val; }));
            }
        }
    }, [value, single, setValue]);
    var contextValue = react_1.useMemo(function () { return ({
        value: value,
        toggleActive: toggleActive
    }); }, [value, toggleActive]);
    var context = hooks_2.collapseContext;
    return (react_1.default.createElement(context.Provider, { value: contextValue }, children));
}
exports.default = Collapse;
//# sourceMappingURL=index.js.map